import type { TransactionDocument, TransactionDocumentsResponse } from '@/types/transaction-document';

/**
 * Mock transaction documents data for demo mode
 */
export const mockDocuments: TransactionDocument[] = [
  {
    id: 'tdoc-1',
    fileName: 'CrystalReportViewer1 (2).pdf',
    fileType: 'application/pdf',
    fileSize: 245678,
    documentType: 'Sales Ledger Transaction',
    uploadedAt: '2026-04-20T10:30:00Z',
    uploadedByEmail: 'admin@TMCProductions.com',
    transactionReference: 'INV-0042',
  },
  {
    id: 'tdoc-2',
    fileName: 'Remittance_Advice_Mar26.pdf',
    fileType: 'application/pdf',
    fileSize: 98765,
    documentType: 'Remittance Advice',
    uploadedAt: '2026-03-15T09:15:00Z',
    uploadedByEmail: 'finance@TMCProductions.com',
    transactionReference: 'INV-0042',
  },
  {
    id: 'tdoc-3',
    fileName: 'Invoice_INV-0042_original.pdf',
    fileType: 'application/pdf',
    fileSize: 312400,
    documentType: 'Invoice',
    uploadedAt: '2026-02-01T14:45:00Z',
    uploadedByEmail: 'admin@TMCProductions.com',
    transactionReference: 'INV-0042',
  },
];

export const mockDocumentsResponse: TransactionDocumentsResponse = {
  documents: mockDocuments,
  totalCount: mockDocuments.length,
};
